// extracted by mini-css-extract-plugin
export default {"mainArea":"ProjectMap_mainArea__L1PHV"};